import { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Constants from "../Constants/constants";
import ErrorModal from "../Components/Common/ErrorModal";
import { motion } from "framer-motion";
import { TERipple } from "tw-elements-react";

export default function StartSimulation() {

  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [starting, setStarting] = useState(false);


  async function handleStartSimulationClick(e) {
    e.preventDefault();

    const newErrors = {};
    try {
      setStarting(true);
      const response = await fetch(
        Constants.StartSimulationConstants.ENDPOINT_INICIARFLUXO,
        Constants.CommonConstants.DEFAULT_POST_REQUEST_OPTIONS
      )

      const result = await response.json();
      if (result.success === true)
        navigate('/ChooseOperationType', { state: result })
      else {
        newErrors.result = result.userFriendlyMessage;
        console.log(result.technicalMessage);
      }
    }
    catch (error) {
      newErrors.result = "Não foi possível iniciar a simulação, tente novamente mais tarde.";
      console.log(error);
    }
    finally {
      setStarting(false);
      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        setShowErrorModal(true);
      }
    }
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      
      <div className="flex justify-center items-center md:h-screen">
        <div className="grid grid-cols-1 grid-rows-2 rounded-lg bg-white  lg:max-w-3xl">
          <div className="flex flex-row flex-wrap items-center justify-center">
            <img
              className="h-48 w-48 rounded-t-lg object-cover md:rounded-none md:rounded-l-lg"
              src="/favicon-riobrasil.png"
              alt=""
            />
            <div className="flex flex-row justify-center">
              <div className="relative mx-auto max-w-7xl md:pl-6 ">
                <div className="md:max-w-md">
                  <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl text-center md:text-left">Calculadora de Preços</h1>
                  <p className="mt-4 text-xl text-gray-500 text-center sm:text-left">Aqui você poderá simular quanto custará a sua operação na Rio Brasil Terminal, atendendo a resolução ANTAQ nº 109, de 17 de Novembro de 2023.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-row justify-center pt-12 md:pt-0 md:items-center">
            <TERipple rippleColor="light">
              <button
                disabled={starting}
                onClick={handleStartSimulationClick}
                className="rounded-md border border-transparent bg-orange-600 px-8 py-3 text-center font-medium text-white hover:bg-orange-700">
                {starting ? "Aguarde..." : "Iniciar simulação"}
                {starting && <svg id="spinner" aria-hidden="true" class="inline ml-1 w-4 h-4 text-gray-200 animate-spin fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                  <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                </svg>}
              </button>
            </TERipple>
          </div>
        </div>
      </div>
      <ErrorModal open={showErrorModal} onOpen={() => setShowErrorModal(false)} children={errors}></ErrorModal>
    </motion.div>
  );
};